module.exports = __webpack_public_path__ + "img/12.c4e50b92.png";